import script from "./CustomPropertyValuesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomPropertyValuesList.vue?vue&type=script&lang=ts&setup=true"

import "./CustomPropertyValuesList.vue?vue&type=style&index=0&id=a7fbaeda&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7fbaeda"]])

export default __exports__